import React, { useMemo } from "react";
import { map } from "lodash";
import { SwitchBar } from "../components/SwitchBar/SwitchBar";
import { ImgList } from "../components/ImgList/ImgList";
import styles from "./TouristAttraction.module.scss";
export function TouristAttraction(props) {
  return /*#__PURE__*/React.createElement(SwitchBar, {
    sliderCount: props.destination_list.length
  }, map(props.destination_list, function (item, index) {
    return /*#__PURE__*/React.createElement(TouristAttractionItem, {
      key: index,
      item: item
    });
  }));
}
function TouristAttractionItem(props) {
  var imgs = useMemo(function () {
    return props.item.slidable_tourist_attraction_images.map(function (item) {
      return item.image;
    });
  }, [props.item.slidable_tourist_attraction_images]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.touristAttraction
  }, /*#__PURE__*/React.createElement("p", {
    className: styles.desc
  }, props.item.gallery_title), /*#__PURE__*/React.createElement("div", {
    className: styles.title
  }, props.item.tourist_attraction_name), /*#__PURE__*/React.createElement(ImgList, {
    list: imgs
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.assetsSource
  }, /*#__PURE__*/React.createElement("img", {
    src: props.item.source.source_icon,
    alt: ""
  }), /*#__PURE__*/React.createElement("div", null, props.item.source.source_text)));
}